import { FC } from 'react';
import useNavigateWithToast from '../../../utils/useNavigateWithToast/useNavigateWithToast';
import Header from "../../Bases/Header";
import CreateClassForm from "./CreateClassForm";

const AddClass: FC = () => {
  const navigateWithToast = useNavigateWithToast();

  const navigateToTableWithSuccessToast = () => {
    navigateWithToast(
        `/tables/classes`,
        {
          label: "Class has been created successfully",
          id: 'classUpdateSuccess'
        }
    );
  }

  return (
      <>
        <Header
            breadcrumb={{ label: 'Back to Class Table', to: '/tables/classes' }}
            title={`Add New Class`}
        />
        <CreateClassForm
            onSuccess={navigateToTableWithSuccessToast}
        />
      </>
  );
};

export default AddClass;
